<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-form ref="form" @submit.prevent="createProduct">
        <v-card elevation="6" class="mb-10">
          <div class="pa-3">
            <div>
              <div class="img_grid">
                <div class="mt-3 mr-2">
                  <div class="d-flex">
                    <div class="ml-1" style="font-size: 22px">เพิ่มข้อมูลสินค้า</div>
                  </div>
                  <div class="mt-6">
                    <div class="ml-4">
                      <v-img height="200" max-width="200" v-if="imagePreviewURL == null" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                      <v-img height="200" max-width="200" v-if="imagePreviewURL != null" :src="imagePreviewURL" class="preview mx-auto"></v-img>
                    </div>
                  </div>
                  <div class="">
                    <div class="mt-3 mb-5 ml-1">
                      <v-file-input small-chips color="#86bc3a" label="รูปภาพสินค้าหลัก" prepend-icon="mdi-camera" hide-details="auto" v-model="pro_pic_name" @change="onFileChange"></v-file-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex mt-4">
                <div class="ml-1" style="font-size: 22px"></div>
              </div>
              <div class="pa-3">
                <div class="d-flex">
                  <div class="ml-1" style="font-size: 22px">รูปภาพเพิ่มเติม</div>
                  <div class="ml-3 mt-n1">
                    <v-btn @click="multi_img" class="white--text grad-success-bg rounded pl-1 pr-1" title="เพิ่ม">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </div>
                <div class="grid_multi_img">
                  <div class="mr-2" v-for="(count, index) in img_list" :key="index">
                    <div class="mt-6">
                      <div class="ml-4">
                        <v-img height="200" max-width="200" v-if="count.product_preview === null" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                        <v-img height="200" max-width="200" v-if="count.product_preview !== null" :src="count.product_preview" class="preview mx-auto"></v-img>
                      </div>
                    </div>
                    <div class="mt-3 mb-5 ml-1">
                      <div class="grid_input">
                        <div class="">
                          <v-file-input small-chips :clearable="false" color="#86bc3a" label="รูปภาพสินค้าเพิ่มเติม" prepend-icon="mdi-camera" hide-details="auto" v-model="count.product_img_multi" @change="onFileChangeMulti(count.id, count.product_img_multi)"></v-file-input>
                        </div>
                        <div class="ml-1" v-if="img_list.length > 0">
                          <div class="pt-4 pl-3 img_hover" @click="delete_img(count.id)"><v-icon title="ลบ">mdi-trash-can-outline</v-icon></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อสินค้า" prepend-inner-icon="mdi-cart-outline" :rules="productRule" hide-details="auto" required v-model="product_Add.name" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="ชื่อทางการแพทย์" prepend-inner-icon="mdi-beaker-outline" hide-details="auto" :rules="medicRule" required v-model="product_Add.medic_name" outlined></v-text-field>
                </div>

                <div class="mt-3 mr-1">
                  <v-autocomplete clearable color="#86bc3a" :items="get_Product" item-text="name" item-value="id" label="ประเภทสินค้า" :rules="typeProductRule" required prepend-inner-icon="mdi-format-list-bulleted-type" hide-details="auto" v-model="product_Add.type_product" outlined></v-autocomplete>
                </div>

                <div class="mt-3 mr-1">
                  <v-autocomplete multiple small-chips clearable color="#86bc3a" :items="supplierType" item-text="name" item-value="id" label="ซัพพลายเออร์"  :rules="typeSupplierRule" required prepend-inner-icon="mdi-semantic-web" hide-details="auto" v-model="product_Add.type_supplier" outlined></v-autocomplete>
                </div>

                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" type="number" label="จำนวนสินค้าในคลังไม่ควรน้อยกว่า" min="0" @keypress="isOnlyNumber($event)" prepend-inner-icon="mdi-book-arrow-up-outline" :rules="limitRule" required hide-details="auto" v-model="product_Add.limit" outlined></v-text-field>
                </div>

                <div class="d-flex align-center">
                  <v-checkbox color="#86bc3a" class="ma-4 ml-6" v-model="product_Add.retail_status" hide-details="auto"></v-checkbox>
                  <div>
                    ขายปลีก (แสดงสินค้าขายเฉพาะขายปลีกเท่านั้น)
                  </div>
                </div>

              </div>
              <div class="grid_full mt-10">
                <div class="mt-3 mr-1">
                  <v-textarea color="#86bc3a" label="รายละเอียด" prepend-inner-icon="mdi-text" hide-details="auto" v-model="product_Add.details" outlined></v-textarea>
                </div>
              </div>
              <div class="grid_half">
                <div class="mt-3 ml-1">
                  <div class="d-flex align-center">
                    <v-checkbox color="#86bc3a" class="ma-4 ml-6" v-model="product_Add.product_claim" hide-details="auto"></v-checkbox>
                    <div>
                      ลูกค้าส่งสามารถเครมสินค้าหมดอายุได้
                    </div>
                  </div>
                </div>
                <div class="mt-3 ml-1" v-if="product_Add.product_claim === true">
                  <v-autocomplete color="#86bc3a" :items="items" item-text="name" item-value="id" :rules="[v => !!v || 'กรุณาเลือกเงื่อนไขการเคลมสินค้า']" prepend-inner-icon="mdi-progress-question" label="เงื่อนไขการเคลมสินค้า" hide-details="auto" v-model="product_Add.condition_product" outlined/>
                </div>
              </div>
              <div class="grid_full" v-if="$store.state.status == 1 || $store.state.status == 2">
                <div class="mt-3 ml-1">
                  <v-text-field color="#86bc3a" type="text" label="หมายเหตุ (หมายเหตุนี้จะไม่แสดงในส่วนของลูกค้า)" prepend-inner-icon="mdi-message-bulleted" hide-details="auto" v-model="product_Add.note" outlined></v-text-field>
                </div>
              </div>
            </div>
          </div>
        </v-card>
        <div class="mt-2">
          <v-card elevation="6">
            <div class="pa-3">
              <div class="mt-3 mr-1">
                <div class="d-flex">
                  <div class="ml-1">เพิ่มข้อมูลหน่วยนับ</div>
                </div>
              </div>
              <div class="mb-n7">
                <small style="color:red;">* หน่วยหลัก</small>
              </div>
              <div class="grid_col mt-5">
                <div class="mt-3 mr-1">
                  <v-autocomplete color="#86bc3a" clearable :items="type_unit" :rules="unitRule" item-text="name" item-value="id" label="หน่วยนับ" hide-details="auto" v-model="product_Add.main_unit_type" outlined/>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" label="บาร์โค้ด" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกบาร์โค้ด']" v-model="product_Add.main_barcode" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1">
                  <v-text-field color="#86bc3a" type="number" label="น้ำหนัก(กิโลกรัม)" :rules="[v => !!v || 'กรุณากรอกน้ำหนัก(กิโลกรัม)']" @keypress="isCurrency($event, product_Add.main_weight)" min="0" hide-details="auto" v-model="product_Add.main_weight" outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1 d-flex">
                  <v-text-field color="#86bc3a" type="number" label="จำกัดการซื้อห้ามเกิน" @keypress="isOnlyNumber($event)" min="0" hide-details="auto" v-model="product_Add.main_limit_purchase" outlined></v-text-field>
                </div>
              </div>
              <div v-for="(unit,index) in unitList" :key="index">
                <div class="grid_col mt-5">
                  <div class="mt-3 mr-1">
                    <v-autocomplete color="#86bc3a" clearable :items="second_unit" :rules="unitRule" item-text="name" item-value="id" label="หน่วยนับ" hide-details="auto" v-model="unit.unit_type" outlined/>
                  </div>
                  <div class="mt-3 mr-1">
                    <v-text-field color="#86bc3a" label="บาร์โค้ด" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกบาร์โค้ด']" v-model="unit.barcode" outlined></v-text-field>
                  </div>
                  <div class="mt-3 mr-1">
                    <v-text-field color="#86bc3a" type="number" label="น้ำหนัก(กิโลกรัม)" :rules="[v => !!v || 'กรุณากรอกน้ำหนัก(กิโลกรัม)']" @keypress="isCurrency($event, unit.weight)" min="0" hide-details="auto" v-model="unit.weight" outlined></v-text-field>
                  </div>
                  <div class="mt-3 mr-1 d-flex">
                    <v-text-field color="#86bc3a" type="number" label="จำกัดการซื้อห้ามเกิน" @keypress="isOnlyNumber($event)" min="0" hide-details="auto" v-model="unit.limit_purchase" outlined></v-text-field>
                    <div class="ml-1" v-if="unitList.length > 0">
                      <v-btn @click="deleteUnit(unit.id)" height="55" class="grad-danger-bg white--text"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right mt-3">
                <v-btn large @click="addUnit()" class="white--text grad-success-bg" style="font-size: 18px">เพิ่มหน่วยนับ</v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn large class="white--text grad-success-bg" style="font-size: 18px" type="submit">บันทึกข้อมูล</v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script src="@/previewimage.js"></script><script>
import img_holder from "@/assets/pharmacy.png"
import {HTTP} from "@/axios.js";
import Swal from "sweetalert2";
import {onlyForCurrency, onlyForNumber} from "@/js/handler";

export default {
  name: "Product_add",
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  data() {
    return {
      img_holder: img_holder,
      pro_pic_name: null,
      imagePreviewURL: null,
      loading_page: false,
      name: null,
      status_id: null,
      status_retail: null,
      productRule: [v => !!v || 'กรุณากรอกชื่อสินค้า'],
      medicRule: [v => !!v || 'กรุณากรอกชื่อทางการแพทย์'],
      typeProductRule: [v => !!v || 'กรุณากรอกประเภทสินค้า'],
      typeSupplierRule: [v => !!v || 'กรุณากรอกซัพพลายเออร์'],
      limitRule: [v => !!v || 'กรุณากรอกจำนวนสินค้าไม่ควรน้อยกว่า'],
      unitRule: [v => !!v || 'กรุณาเลือกหน่วยนับ'],
      get_Product: [],
      selected_product: null,
      supplierType: [],
       // { id: 1, name: '30 วัน' },
        // { id: 2, name: '90 วัน' },
      items: [
       
        { id: 3, name: '120 วัน' },
        { id: 4, name: '240 วัน' },
        { id: 5, name: '365 วัน' },
      ],
      typeItems: [
        { id: 1, name: 'กล่อง' },
        { id: 2, name: 'แพ็ค' },
        { id: 3, name: 'แผง' },
        { id: 4, name: 'เม็ด' },
      ],
      type_unit: [],
      product_Add: {
        id: null,
        code: null,
        name: null,
        medic_name: null,
        type_product: null,
        limit: null,
        limit_purchase: null,
        type_supplier: null,
        details: null,
        product_claim: false,
        retail_status: false,
        condition_product: 0,
        note: '-',
        main_unit_type: null,
        main_barcode: null,
        main_weight: null,
        main_limit_purchase: null,
      },
      unitList: [],
      unit_id: 0,
      img_list: [],
      multi_id: 0,
      second_unit: [],
    }
  },
  methods: {
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.pro_pic_name = null
          })
        }else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.pro_pic_name = null
          }
        }
      }
      else {
        this.imagePreviewURL = null
        this.pro_pic_name = null
      }
    },
    onFileChangeMulti(mul_id, payload) {
      let file = payload
      this.img_list.forEach((data) => {
        if (data.id === mul_id) {
          if (payload !== null && payload !== undefined) {
            let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
            let file_ext = file.name;
            let ext = file_ext.split('.').pop().toLowerCase();
            if (parseInt(extall.indexOf(ext)) < 0) {
              Swal.fire({
                text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                data.product_preview = null
                data.product_img_multi = null
              })
            }
            else {
              if (file) {
                data.product_img_multi = file
                data.product_preview = URL.createObjectURL(file)
                URL.revokeObjectURL(file)
              }
              else {
                data.product_preview = null
                data.product_img_multi = null
              }
            }
          }
          else {
            data.product_preview = null
            data.product_img_multi = null
          }
        }
      })
    },
    addUnit() {
      this.unit_id += 1;
      this.unitList.push({
        "id": this.unit_id,
        "unit_type": null,
        "barcode": null,
        "weight": null,
        "limit_purchase": null,
      })
    },
    deleteUnit(id) {
      this.unitList = this.unitList.filter(detail => detail.id !== id)
    },
    multi_img() {
      this.multi_id += 1;
      this.img_list.push({
        id: this.multi_id,
        product_img_multi: [],
        product_preview: null,
      })
    },
    delete_img(id) {
      this.img_list = this.img_list.filter(detail => detail.id !== id)
    },
    genIdCode() {
      HTTP.post('/products/product/getproid')
          .then((res) => {
            if (res.data.success === true){
              this.product_Add.code = res.data.object;
            }
          })
    },
    getProduct_type() {
      HTTP.post('/products/producttype/all')
          .then((res) => {
            if (res.data.success === true){
              this.get_Product = res.data.object;
            }
          })
    },
    getUnitType() {
      HTTP.get('/products/units/one')
          .then((res) => {
            if (res.data.success === true){
              this.type_unit = res.data.object;
            }
          })
    },
    getUnit_more() {
      HTTP.get('/products/units/moreone')
          .then((res) => {
            if (res.data.success === true){
              this.second_unit = res.data.object;
            }
          })
    },
    createProduct() {
      if (this.product_Add.product_claim == true) {
        this.status_id = 1;
      }
      else if (this.product_Add.product_claim == false) {
        this.status_id = 0;
      }

      if (this.product_Add.retail_status == true) {
        this.status_retail = 1;
      }
      else if (this.product_Add.retail_status == false) {
        this.status_retail = 0;
      }

      if (this.status_id == 1){
        if (this.$refs.form.validate()) {
          if (this.pro_pic_name !== null && this.pro_pic_name !== '') {
            let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
            let file = this.pro_pic_name.name;
            let ext = file.split('.').pop().toLowerCase();
            if (parseInt(extall.indexOf(ext)) < 0) {
              Swal.fire({
                text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.imagePreviewURL = null
                this.pro_pic_name = null
              })
            }
            else {
              let config = {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              };
              let formData = new FormData();
              formData.append('product_image', this.pro_pic_name, this.pro_pic_name.name)
              formData.append('product_code', this.product_Add.code)
              formData.append('product_name', this.product_Add.name)
              formData.append('product_type', this.product_Add.type_product)
              formData.append('product_detail', this.product_Add.details)
              formData.append('medical_name', this.product_Add.medic_name)
              formData.append('suppliers', JSON.stringify(this.product_Add.type_supplier))
              formData.append('min_qty', this.product_Add.limit)
              formData.append('claim_status', this.status_id)
              formData.append('retail_status', this.status_retail)
              formData.append('condition_id', this.product_Add.condition_product)
              formData.append('note', this.product_Add.note)
              formData.append('main_unit_type', this.product_Add.main_unit_type)
              formData.append('main_barcode', this.product_Add.main_barcode)
              formData.append('main_weight', this.product_Add.main_weight)
              formData.append('main_limit_purchase', this.product_Add.main_limit_purchase)
              let arr_img = []
              this.img_list.forEach((data, index) => {
                arr_img = data.product_img_multi
                formData.append('picture_more[' + index + ']', arr_img)
              })
              let arr_all = [];
              this.unitList.forEach((detail) => {
                arr_all.push({
                  "unit_type": detail.unit_type,
                  "barcode": detail.barcode,
                  "weight": detail.weight,
                  "limit_purchase": detail.limit_purchase,
                })
              });
              formData.append('unit_add', JSON.stringify(arr_all))
              HTTP.post('/products/product/create', formData, config)
                  .then((res) => {
                    if (res.data.success === true){
                      Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
                          .then(() => {
                            // this.$router.push('/stock/manage_product/productlist');
                            this.$router.push('/'+ this.$store.state.link_url)
                          })
                    }
                    else {
                      Swal.fire({
                        title: 'ไม่สามารถดำเนินการได้ !',
                        text: res.data.message,
                        icon: 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: `ตกลง`,
                        denyButtonText: `ยกเลิก`,
                      })
                    }
                  })
            }
          }
          else {
            let config = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            };
            let formData = new FormData();
            formData.append('product_code', this.product_Add.code)
            formData.append('product_name', this.product_Add.name)
            formData.append('product_type', this.product_Add.type_product)
            formData.append('product_detail', this.product_Add.details)
            formData.append('medical_name', this.product_Add.medic_name)
            formData.append('suppliers', JSON.stringify(this.product_Add.type_supplier))
            formData.append('min_qty', this.product_Add.limit)
            formData.append('claim_status', this.status_id)
            formData.append('retail_status', this.status_retail)
            formData.append('condition_id', this.product_Add.condition_product)
            formData.append('note', this.product_Add.note)
            formData.append('main_unit_type', this.product_Add.main_unit_type)
            formData.append('main_barcode', this.product_Add.main_barcode)
            formData.append('main_weight', this.product_Add.main_weight)
            formData.append('main_limit_purchase', this.product_Add.main_limit_purchase)
            let arr_img = []
            this.img_list.forEach((data, index) => {
              arr_img = data.product_img_multi
              formData.append('picture_more[' + index + ']', arr_img)
            })
            let arr_all = [];
            this.unitList.forEach((detail) => {
              arr_all.push({
                "unit_type": detail.unit_type,
                "barcode": detail.barcode,
                "weight": detail.weight,
                "limit_purchase": detail.limit_purchase,
              })
            });
            formData.append('unit_add', JSON.stringify(arr_all))
            HTTP.post('/products/product/create', formData, config )
                .then((res) => {
                  if (res.data.success === true){
                    Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
                        .then(() => {
                          // this.$router.push('/stock/manage_product/productlist');
                          this.$router.push('/'+ this.$store.state.link_url)
                        })
                  }
                  else {
                    Swal.fire({
                      title: 'ไม่สามารถดำเนินการได้ !',
                      text: res.data.message,
                      icon: 'error',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: `ตกลง`,
                      denyButtonText: `ยกเลิก`,
                    })
                  }
                })
          }
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'กรุณากรอกข้อมูล !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
      else {
        if (this.$refs.form.validate()) {
          if (this.pro_pic_name !== null && this.pro_pic_name !== '') {
            let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
            let file = this.pro_pic_name.name;
            let ext = file.split('.').pop().toLowerCase();
            if (parseInt(extall.indexOf(ext)) < 0) {
              Swal.fire({
                text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                this.imagePreviewURL = null
                this.pro_pic_name = null
              })
            }
            else {
              let config = {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              };
              let formData = new FormData();
              formData.append('product_image', this.pro_pic_name, this.pro_pic_name.name)
              formData.append('product_code', this.product_Add.code)
              formData.append('product_name', this.product_Add.name)
              formData.append('product_type', this.product_Add.type_product)
              formData.append('product_detail', this.product_Add.details)
              formData.append('medical_name', this.product_Add.medic_name)
              formData.append('suppliers', JSON.stringify(this.product_Add.type_supplier))
              formData.append('min_qty', this.product_Add.limit)
              formData.append('claim_status', this.status_id)
              formData.append('retail_status', this.status_retail)
              formData.append('condition_id', this.product_Add.condition_product)
              formData.append('note', this.product_Add.note)
              formData.append('main_unit_type', this.product_Add.main_unit_type)
              formData.append('main_barcode', this.product_Add.main_barcode)
              formData.append('main_weight', this.product_Add.main_weight)
              formData.append('main_limit_purchase', this.product_Add.main_limit_purchase)
              let arr_img = []
              this.img_list.forEach((data, index) => {
                arr_img = data.product_img_multi
                formData.append('picture_more[' + index + ']', arr_img)
              })
              let arr_all = [];
              this.unitList.forEach((detail) => {
                arr_all.push({
                  "unit_type": detail.unit_type,
                  "barcode": detail.barcode,
                  "weight": detail.weight,
                  "limit_purchase": detail.limit_purchase,
                })
              });
              formData.append('unit_add', JSON.stringify(arr_all))
              HTTP.post('/products/product/create', formData, config )
                  .then((res) => {
                    if (res.data.success === true){
                      Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
                          .then(() => {
                            // this.$router.push('/stock/manage_product/productlist');
                            this.$router.push('/'+ this.$store.state.link_url)
                          })
                    }
                    else {
                      Swal.fire({
                        title: 'ไม่สามารถดำเนินการได้ !',
                        text: res.data.message,
                        icon: 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: `ตกลง`,
                        denyButtonText: `ยกเลิก`,
                      })
                    }
                  })
            }
          }
          else {
            let config = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            };
            let formData = new FormData();
            formData.append('product_code', this.product_Add.code)
            formData.append('product_name', this.product_Add.name)
            formData.append('product_type', this.product_Add.type_product)
            formData.append('product_detail', this.product_Add.details)
            formData.append('medical_name', this.product_Add.medic_name)
            formData.append('suppliers', JSON.stringify(this.product_Add.type_supplier))
            formData.append('min_qty', this.product_Add.limit)
            formData.append('claim_status', this.status_id)
            formData.append('retail_status', this.status_retail)
            formData.append('condition_id', this.product_Add.condition_product)
            formData.append('note', this.product_Add.note)
            formData.append('main_unit_type', this.product_Add.main_unit_type)
            formData.append('main_barcode', this.product_Add.main_barcode)
            formData.append('main_weight', this.product_Add.main_weight)
            formData.append('main_limit_purchase', this.product_Add.main_limit_purchase)
            let arr_img = []
            this.img_list.forEach((data, index) => {
              arr_img = data.product_img_multi
              formData.append('picture_more[' + index + ']', arr_img)
            })
            let arr_all = [];
            this.unitList.forEach((detail) => {
              arr_all.push({
                "unit_type": detail.unit_type,
                "barcode": detail.barcode,
                "weight": detail.weight,
                "limit_purchase": detail.limit_purchase,
              })
            });
            formData.append('unit_add', JSON.stringify(arr_all))
            HTTP.post('/products/product/create', formData, config )
                .then((res) => {
                  if (res.data.success === true){
                    Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
                        .then(() => {
                          // this.$router.push('/stock/manage_product/productlist');
                          this.$router.push('/'+ this.$store.state.link_url)
                        })
                  }
                  else {
                    Swal.fire({
                      title: 'ไม่สามารถดำเนินการได้ !',
                      text: res.data.message,
                      icon: 'error',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: `ตกลง`,
                      denyButtonText: `ยกเลิก`,
                    })
                  }
                })
          }
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: 'กรุณากรอกข้อมูล !',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          })
        }
      }
    },
    getSupplier() {
      HTTP.post('/suppliers/all')
          .then((res) => {
            if (res.data.success === true){
              this.supplierType = res.data.object.map((obj) => {
                return {
                  id: obj.id,
                  name: obj.department !== '-' && obj.department !== null ? obj.name +' ('+ obj.department +')': obj.name,
                }
              });
            }
          })
    }
  },
  mounted() {
    this.getProduct_type();
    this.getSupplier();
    this.genIdCode();
    this.getUnitType();
    this.getUnit_more();
  }
}
</script>

<style lang="scss">
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}
.grid_col {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.grid_img {
  display: grid;
  grid-template-columns: 25% 85%;
}
.preview {
  border-radius: 8px;
}
.img_grid {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-gap: 15px 0;
}
.grid_multi_img {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}
.grid_input {
  display: grid;
  grid-template-columns: 90% 10%;
}
.img_hover {
  cursor: pointer;
}
@media only screen and (max-width: 1100px) {
  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_col {
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .img_grid {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
@media only screen and (max-width: 650px) {
  .grid_col {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_multi_img {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
